import React from 'react';
// Os estilos dos termos nasceram junto do cadastro do prestador e continuam la:
// as classes sao as mesmas, entao importar a folha inteira evita duplicar o
// bloco em tres media queries so para trocar o prefixo.
import '../serviceProvider/serviceProvider.scss';
import TermsPage from './termsPage';
import { DEFAULT_TERMS_AUDIENCE, TERMS_AUDIENCES, findTermsPage } from './termsDocuments';

// Rota publica dos termos, sem cabecalho de marca e sem caminho de volta. Existe
// para ser embutida: a WebView do app abre /realEstate/termos/<slug>?publico=usuario
// (ou /<companyId>/realEstate/termos/<slug>, com as cores da imobiliaria) e sai
// pelo botao nativo. O publico decide qual versao do documento aparece. A classe
// de body que esconde o Header global e as cores da empresa vem de realEstate/index.js.
function Terms({ match, location }) {
  const slug = (match && match.params && match.params.slug) || '';
  const page = findTermsPage(slug);
  const requestedAudience = new URLSearchParams(location ? location.search : '').get('publico');
  const audience = TERMS_AUDIENCES.includes(requestedAudience)
    ? requestedAudience
    : DEFAULT_TERMS_AUDIENCE;

  return (
    <div className="service-provider">
      <TermsPage title={page ? page.title : 'Termos'} audience={audience} />
    </div>
  );
}

export default Terms;
